import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialLaboratoryPersonnelState: Dtos.LaboratoryPersonnel & IRegistrationFormState = {
    id: null,
    laboratoryId: null,
    laboratory: null,
    personnelId: null,
    personnel: null,
    positionNo: null,
    roleId: null,
    role: null,
    dateStarted: null,
    dateCeased: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ILaboratoryPersonnelReduxFormState {
    id: IFieldState<number>,
    laboratoryId: IFieldState<number>,
    personnelId:IFieldState<number>,
    positionNo: IFieldState<number>,
    roleId: IFieldState<number>,
    dateStarted: IFieldState<string>,
    dateCeased: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>
}